module.exports = "https://cdn-challenge.mathletics.com/app/293/assets/images/f65da4a6cbb8daa615422ce7ee38d9b4.svg";